import React, { useState } from "react";
import Button, { IconButton } from "../../buttons";
import { ReportSelect } from "../../forms/selects";
import { useAuth } from "react-oidc-context";
import { useClientContext } from "../../../hooks/ClientContext";
import { openCreateClientReportModal } from "../../modals/client-report-create";
import { toNString } from "../../../helpers/guids";
import { ClientReportType } from "../../../types/ClientReportType";
import { DefReactSelectOption } from "../../../types/DefReactSelectOption";

export type ClientReportSearchProps = {
    autoSelect?: boolean,
    buttonSize?: 'sm' | 'md' | 'lg' | 'xl',
    formError?: any,
    label?: string | null | undefined,
    labelPosition?: 'top' | 'side',
    onReportCreated?: (report: ClientReportType, autoSelect: boolean) => void,
    onReportSelected?: (opt: DefReactSelectOption<ClientReportType>, data: ClientReportType) => void,
    value: string,
    allowCreate?: boolean,
    onClickCreate?: (() => void) | null | undefined,
    reportSelectProps: any,
};

export const ClientReportSearch = ({ 
    autoSelect = true,
    buttonSize = "lg", 
    formError = null,
    label = "Select Project:", 
    labelPosition = "side",
    onReportCreated = () => console.warn('onReportCreated has not been assigned.'), 
    onReportSelected = () => console.warn('onReportSelected has not been assigned.'),
    value,
    allowCreate = true,
    onClickCreate = null,
    reportSelectProps = {},
    ...rest 
} : Readonly<ClientReportSearchProps>) => {
    const auth = useAuth();
    const profile = auth.user!.profile;
    const { account: { adviserId, divisionId, masterAccountId } } = useClientContext();

    const handleShow = () => {
        if (!allowCreate) {
            return;
        }
        if (onClickCreate && typeof onClickCreate === 'function') {
            onClickCreate();
        }
        openCreateClientReportModal({
            adviserId,
            authorId: null,
            divisionId,
            masterAccountId
        }).then(
            (r) => onReportCreated(r, autoSelect)
        );
    };

    return (
        <div className="row" {...rest}>
            <div className="col d-flex justify-content-start align-items-center">
                <ReportSelect 
                    masterAccountId={masterAccountId}
                    label={labelPosition === 'side' ? null : label}
                    errorMessage={formError}
                    value={value}
                    setValue={(e) => onReportSelected(e, e.data)}
                    {...reportSelectProps}
                />
            </div>
            <div className={`col-md-auto d-flex justify-content-end ${formError != null ? 'align-items-center' : 'align-items-end'}`}>
                {buttonSize === 'lg' && (
                    <Button variant="success" onClick={handleShow}>Create new Report</Button>
                )}
                {buttonSize !== 'lg' && (
                    <IconButton icon="fa-plus" variant="success" onClick={handleShow} />
                )}
            </div>
        </div>
    )
};

export default ClientReportSearch;